<div class="body">
  <div class="container pt-3">
    <div class="row title-box mt-3">
      <div class="col-12 col-sm-12">
        <h3 class="txtbienvenida">Parametrización actividades <span class="txtbienvenida-2">económicas excluidas</span></h3>
      </div>
    </div>
    <form [formGroup]="ciuuForm" class="custom-form">
      <div class="row mt-5">
        <div class="col-12">
          <div class="mb-3">
            <select #select_ciiu id="select_ciiu" class="col-12 col-lg-12 selectpicker" title="No se ha seleccionado ningun CIIU" data-size="5" data-live-search="true" multiple  formControlName="ciiu" data-width="100%">
              @for (ciiu of ciius; track ciiu) {
                <option [(value)]="ciiu.codigoCiiu">{{ciiu.codigoCiiu}} -
                  {{ciiu.nombreCiiu}}
                </option>
              }
            </select>
          </div>
        </div>
      </div>
    </form>

    <!-- <div class="row mt-5" *ngIf="ciiusMostrar.length>0">
    <div class="col-12">
      <div class="mb-3">
        <h5>CIIUS seleccionados:</h5>
      </div>
    </div>
    <div class="col-12">
      <div class="mb-3">
        <textarea style="width: 98%;" rows="5" disabled [(ngModel)]="ciiusMostrar"></textarea>
      </div>
    </div>
  </div> -->
  <div class="row justify-content-center mt-3 g-3">
    <div class="col-12 col-md-3 container-btn">
      <button type="submit" (click)="registrarCambios()" class="btn btn-primary hvr-shrink" style="width: 190px;">Registrar cambios</button>
    </div>
    <div class="col-12 col-md-3 container-btn">
      <button type="submit" (click)="cancelar()" class="btn btn-primary hvr-shrink" style="width: 190px;">Volver</button>
    </div>
  </div>
  @if (ciiusMostrar.length > 0) {
    <div class="row mt-5">
      <div class="col-12">
        <div class="mb-3">
          <h5>CIIUS seleccionados:</h5>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-striped table-borderless rounded">
          <thead class="table_head">
            <tr>
              <th scope="col" class="no-styles table-header" id="codigoCiiu">Código CIIU</th>
              <th scope="col" class="no-styles table-header" id="nombreCiiu">Nombre CIIU</th>
            </tr>
          </thead>
          <tbody>
            @for (ciiu of ciiusMostrar | paginate:{itemsPerPage: 10, currentPage:pageActual}; track ciiu) {
              <tr>
                <th scope="row" id="id-monto">{{ciiu.codigoCiiu}}</th>
                <td>{{ciiu.nombreCiiu}}</td>
              </tr>
            }
          </tbody>
        </table>
        <nav style="float: right;">
          <ul class="pagination">
            <li class="page-item">
              <pagination-controls class="paginate_button" (pageChange)="pageActual = $event"
              previousLabel='' nextLabel=''></pagination-controls>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  }
</div>
<div class="footer-body"></div>
</div>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
